// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"styles_descriptionContainer__+2Xsy","descriptionCard":"styles_descriptionCard__IWSQA"};